export default {"src":"/_next/static/media/getpacked_Logo_schwarz.531070a4.svg","height":43,"width":213};